import { render, staticRenderFns } from "./PieChartSkeletonLoader.vue?vue&type=template&id=8a061baa&scoped=true&"
import script from "./PieChartSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./PieChartSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./PieChartSkeletonLoader.vue?vue&type=style&index=0&id=8a061baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a061baa",
  null
  
)

export default component.exports